import { formatDate } from '@angular/common';
import { computed, input } from '@angular/core';
import { Store } from '@ngrx/store';
import cloneDeep from 'lodash.clonedeep';
import { clearPageErrorMessage, setPageErrorMessage, } from 'Angular/features/components/page-error-message/state/page-error-message.action';
import { setFundChartZoom } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/zoom/zoom.actions';
import { hasValidRequestData } from 'ChartApp/ts/features/fund-chart-page-shared/state/fund-chart.selectors';
import { COPY_URL_LINK, DOWNLOAD, EMBED, EMBED_TYPE_IMAGE_CODE, EXPORT, EXPORT_PROHIBITED_ERRORS, PDF_FORMAT, PRINT, SHARE, TWEET, } from 'Angular/constants/core.constants';
import { CHART_BASE_SHARING_URL_OPTIONS, FUND_CHART_EXPORTING_OPTIONS, SAVED_FUND_CHART_SHARING_OPTIONS, } from 'ChartApp/ts/apps/fund-chart/constants';
import { CHART_IMAGE_FEATURE, DATA_EXPORT_FEATURE, STATIC_PDF_FEATURE, } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.constants';
import { SavedItemType } from 'Angular/features/components/saved-items/enums/saved-item-type.enum';
import { ChartDateZoom } from 'ChartApp/ts/enums/chart-common.enum';
import { FundChartAppStateManager } from '../../services/fund-chart-app.service';
import { ExportService } from 'ChartApp/ts/services/export-service/export.service';
import { FundChartService } from 'ChartApp/ts/services/fund-chart.service';
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
import { SelectedFolderableService } from 'FoldersApp/services/selected-folderable.service';
import { ChartEmbedModalComponent } from 'Angular/features/components/modals/chart-embed-modal/chart-embed-modal.component';
import { SharingModalComponent } from 'Angular/features/components/modals/sharing-modal/sharing-modal.component';
import { UrlShortenerModalComponent } from 'Angular/features/components/modals/url-shortener-modal/url-shortener-modal.component';
import { PdfTitleModalComponent } from 'Angular/features/components/pdf-title-modal/pdf-title-modal.component';
import { FeatureNeededComponent } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.component';
import { downloadUrlWrapper } from 'Angular/utils/download';
import * as i0 from "@angular/core";
import * as i1 from "../../services/fund-chart-app.service";
import * as i2 from "EntitlementsApp/ts/features/feature-needed/feature.service";
import * as i3 from "ChartApp/ts/services/fund-chart.service";
import * as i4 from "@ngrx/store";
import * as i5 from "FoldersApp/services/selected-folderable.service";
import * as i6 from "@angular/common";
import * as i7 from "../../../../../../../../../ycharts/static/ts/features/components/modals/chart-embed-modal/chart-embed-modal.component";
import * as i8 from "../../../../../../../../entitlements/static/entitlements/ts/features/feature-needed/feature-needed.component";
import * as i9 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i10 from "Angular/features/components/modals/loading-modal/loading-modal.component";
import * as i11 from "Angular/features/components/pdf-title-modal/pdf-title-modal.component";
import * as i12 from "../../../../../../../../../ycharts/static/ts/features/components/modals/sharing-modal/sharing-modal.component";
import * as i13 from "../../../../../../../../../ycharts/static/ts/features/components/dropdowns/simple-dropdown/simple-dropdown.component";
import * as i14 from "../../../../../../../../../ycharts/static/ts/features/components/modals/url-shortener-modal/url-shortener-modal.component";
import * as i15 from "ChartApp/ts/apps/fund-chart/components/fund-chart-saved-item-dropdown/fund-chart-saved-item-dropdown.component";
const _c0 = ["chartEmbedModalComponent"];
const _c1 = ["sharingModalComponent"];
const _c2 = ["urlShortenerModalComponent"];
const _c3 = ["featureNeededComponent"];
const _c4 = ["pdfTitleModal"];
const _c5 = a0 => ({ open: a0 });
function FundChartHeaderComponent_ycn_sharing_modal_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-sharing-modal", 17, 4);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("publicSharingItemType", "saved_fundamental_chart")("shareableItem", ctx_r1.selectedItem);
} }
/**
 *
 * Fund Chart Header Component
 *
 * This component is the header on the fund chart page that allows users to save, open, export, share, reset, etc.
 *
 * Input Properties:
 *  securityPageType: security type for the page that this component is on, if any. Used with the itemType to determine which user preference field to save
 *                    the default state to.
 *  aISummaries: list of AI-generated event summaries to include in exports.
 */
export class FundChartHeaderComponent {
    constructor(fundChartAppStateService, featureService, fundChartService, store, selectedFolderableService) {
        this.fundChartAppStateService = fundChartAppStateService;
        this.featureService = featureService;
        this.fundChartService = fundChartService;
        this.store = store;
        this.selectedFolderableService = selectedFolderableService;
        this.aISummaries = input([], ...(ngDevMode ? [{ debugName: "aISummaries" }] : []));
        this.SAVED_FUND_CHART_ITEM_TYPE = SavedItemType.FUND_CHART;
        this.sharingOptions = SAVED_FUND_CHART_SHARING_OPTIONS;
        this.exportingOptions = FUND_CHART_EXPORTING_OPTIONS;
        // The folder view uses `FolderableItem`. The legacy view uses `ShareableItem`.
        this.selectedItem = null;
        // Exporting
        this.chartHasValidRequestData = false;
        this.exportLoading = false;
        this.AIEventsHTML = computed(() => {
            if (!this.aISummaries().length)
                return null;
            return `<h2>AI Events Summary</h2>${[...this.aISummaries()]
                .sort((a, b) => new Date(a.startDate).valueOf() - new Date(b.startDate).valueOf())
                .map(({ securityId, calc, startDate, endDate, textContent }) => {
                const calcName = calc === 'price' ? 'Price' : 'Total Return Level';
                const dateRangeLabel = `${this.formatLabelDate(new Date(startDate))} - ${this.formatLabelDate(new Date(endDate))}`;
                return (`<div><div class="text-bold">${securityId} - ${calcName}</div>` +
                    `<div class="text-small">${dateRangeLabel}</div></div><div><p>${textContent}</p></div>`);
            })
                .join('')}
                `;
        }, ...(ngDevMode ? [{ debugName: "AIEventsHTML" }] : []));
        this.mapStateToComponent = (state) => {
            const selection = this.selectedFolderableService.getSelection();
            this.selectedItem = selection ? selection.item : null;
            const sharingOptions = cloneDeep(SAVED_FUND_CHART_SHARING_OPTIONS);
            // Determine whether to enable the "Share with Team" option.
            sharingOptions.list[0].disabled = this.selectedItem ? !this.selectedItem.permissions.canShare : true;
            this.sharingOptions = sharingOptions;
            this.fundChartState = state.fundChart;
            this.chartHasValidRequestData = !!hasValidRequestData(state);
            this.embedCodeUrl = this.chartHasValidRequestData
                ? this.fundChartService.getChartEmbedUrl(state.fundChart, EMBED_TYPE_IMAGE_CODE)
                : null;
            this.shareUrlParams = this.chartHasValidRequestData
                ? this.fundChartService.getChartDataUrlQuery(state.fundChart)
                : null;
        };
        this.exportErrorHandler = (response) => {
            const urlTooLongCodes = new Set([414, 413, 507]);
            if (urlTooLongCodes.has(response.status)) {
                this.setErrorMessage('Chart has too many annotations to export. Please remove some annotations and try again.');
            }
            else if (response.status === 403) {
                if (EXPORT_PROHIBITED_ERRORS.includes(response.error)) {
                    // Handle image export errors
                    this.setErrorMessage('Unable to generate fund chart');
                }
                else {
                    // Handles errors when exporting CSV data which is returned as a Blob
                    response.error.text().then((text) => {
                        if (EXPORT_PROHIBITED_ERRORS.includes(text)) {
                            this.setErrorMessage(`Unable to generate fund chart`);
                        }
                    });
                }
            }
            else {
                this.setErrorMessage('An error occurred while exporting the chart image. Please try again or contact support.');
            }
        };
        this.storeSubscription = this.store.select('reducers').subscribe(this.mapStateToComponent);
        const hasChartImageFeature = this.featureService.userHasFeatures([CHART_IMAGE_FEATURE]);
        const hasDataExportFeature = this.featureService.userHasFeatures([DATA_EXPORT_FEATURE]);
        const hasStaticPDFFeature = this.featureService.userHasFeatures([STATIC_PDF_FEATURE]);
        this.exportingOptions.list = this.exportingOptions.list.map((item) => {
            if (item.value === DOWNLOAD || item.value === PRINT)
                return { ...item, disabled: !hasChartImageFeature };
            if (item.value === PDF_FORMAT)
                return { ...item, disabled: !hasStaticPDFFeature };
            if (item.value === EXPORT)
                return { ...item, disabled: !hasDataExportFeature };
            return item;
        });
    }
    ngAfterViewInit() {
        this.exportService = new ExportService(this.fundChartService, this.featureService, this.featureNeededComponent, this.exportErrorHandler);
    }
    ngOnDestroy() {
        this.storeSubscription.unsubscribe();
    }
    sharingHandler(selectedItem) {
        switch (selectedItem) {
            case COPY_URL_LINK:
                this.urlShortenerModalComponent.openModal();
                break;
            case EMBED:
                this.chartEmbedModalComponent.openModal();
                break;
            case TWEET:
                this.shareChart(CHART_BASE_SHARING_URL_OPTIONS.TWITTER);
                break;
            case SHARE:
                this.sharingModalComponent.openModal();
                break;
            default:
                break;
        }
    }
    shareChart(sharingOption) {
        const left = window.screen.width / 2 - sharingOption.width / 2;
        const top = window.screen.height / 2 - sharingOption.height / 2;
        const windowProperties = `popup=1,width=${sharingOption.width},height=${sharingOption.height},screenX=${left},screenY=${top}`;
        // We need to open the window in response to the user click. Otherwise the popup window may be blocked.
        const newWindow = window.open('', '', windowProperties);
        this.fundChartService.getChartShareUrl(sharingOption.url, this.fundChartState).subscribe({
            next: (response) => {
                newWindow.location.href = response.redirectUrl;
            },
            error: (error) => {
                newWindow.close();
                throw error;
            },
        });
    }
    setErrorMessage(message) {
        if (message === '') {
            this.store.dispatch(clearPageErrorMessage());
        }
        else {
            this.store.dispatch(setPageErrorMessage({ message }));
        }
    }
    reset() {
        this.fundChartAppStateService.resetToSystemDefault();
        this.store.dispatch(setFundChartZoom({ zoom: ChartDateZoom.CHART_ZOOM_ONE_YEAR }));
    }
    exportHandler(selectedItem) {
        if (selectedItem === PDF_FORMAT) {
            this.pdfTitleModal.openModal();
        }
        else {
            this.exportService.exportHandler(selectedItem, this.fundChartState, this.AIEventsHTML());
        }
    }
    exportPDF(reportTitle) {
        this.exportLoading = true;
        this.fundChartService.getPDFReportUrl(this.fundChartState, reportTitle).subscribe({
            next: (response) => {
                // Set `onbeforeunload` to null to avoid triggering the "unsaved changes" warning when downloading
                // the PDF. After the download finishes, set the value back to the function set by
                // `SavedItemDropdownComponent` .
                window.onbeforeunload = null;
                downloadUrlWrapper(response.pdf_url).subscribe(() => {
                    this.exportLoading = false;
                });
            },
            error: () => {
                this.exportLoading = false;
                this.setErrorMessage('An error occurred while exporting the pdf. Please try again or contact support.');
            },
        });
    }
    formatLabelDate(date) {
        return `${formatDate(date, 'MMMM dd, yyyy', 'en-US')}`;
    }
}
FundChartHeaderComponent.ɵfac = function FundChartHeaderComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FundChartHeaderComponent)(i0.ɵɵdirectiveInject(i1.FundChartAppStateManager), i0.ɵɵdirectiveInject(i2.FeatureService), i0.ɵɵdirectiveInject(i3.FundChartService), i0.ɵɵdirectiveInject(i4.Store), i0.ɵɵdirectiveInject(i5.SelectedFolderableService)); };
FundChartHeaderComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FundChartHeaderComponent, selectors: [["ycn-fund-chart-header"]], viewQuery: function FundChartHeaderComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
        i0.ɵɵviewQuery(_c1, 5);
        i0.ɵɵviewQuery(_c2, 5);
        i0.ɵɵviewQuery(_c3, 5);
        i0.ɵɵviewQuery(_c4, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.chartEmbedModalComponent = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sharingModalComponent = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.urlShortenerModalComponent = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.featureNeededComponent = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.pdfTitleModal = _t.first);
    } }, inputs: { securityPageType: "securityPageType", aISummaries: [1, "aISummaries"] }, standalone: false, decls: 21, vars: 13, consts: [["chartEmbedModalComponent", ""], ["urlShortenerModalComponent", ""], ["featureNeededComponent", ""], ["pdfTitleModal", ""], ["sharingModalComponent", ""], [1, "page-header", "row"], [1, "page-title", "col-5", "col-md-7"], [1, "page-header-actions", "align-self-center"], ["data-test-id", "export-dropdown", "buttonClass", "btn btn-transparent2 dropdown-toggle", 1, "page-header-action", "dropdown", 3, "handler", "config", "inputDisabled", "dropdownClass"], ["buttonClass", "btn btn-transparent2 dropdown-toggle", 1, "page-header-action", "dropdown", 3, "handler", "config", "dropdownClass"], [1, "page-header-action"], ["data-test-id", "reset-all-button", "href", "javascript:void(0)", 1, "btn", "btn-transparent2", 3, "click"], ["ycnIcon", "", "name", "icon-reset"], [3, "embedCodeUrl"], [3, "publicSharingItemType", "shareableItem", 4, "ngIf"], [3, "submitHandler", "defaultTitle", "submitButtonText"], [3, "loadingText", "modalTrigger"], [3, "publicSharingItemType", "shareableItem"]], template: function FundChartHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 5)(1, "div", 6);
        i0.ɵɵelement(2, "ycn-fund-chart-saved-item-dropdown");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 7)(4, "ycn-simple-dropdown", 8);
        i0.ɵɵlistener("handler", function FundChartHeaderComponent_Template_ycn_simple_dropdown_handler_4_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.exportHandler($event)); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "ycn-simple-dropdown", 9);
        i0.ɵɵlistener("handler", function FundChartHeaderComponent_Template_ycn_simple_dropdown_handler_5_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.sharingHandler($event)); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 10)(7, "a", 11);
        i0.ɵɵlistener("click", function FundChartHeaderComponent_Template_a_click_7_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.reset()); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(8, "svg", 12);
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(9, "span");
        i0.ɵɵtext(10, "Reset All");
        i0.ɵɵelementEnd()()()()();
        i0.ɵɵelement(11, "ycn-chart-embed-modal", 13, 0)(13, "ycn-url-shortener-modal", null, 1);
        i0.ɵɵtemplate(15, FundChartHeaderComponent_ycn_sharing_modal_15_Template, 2, 2, "ycn-sharing-modal", 14);
        i0.ɵɵelement(16, "ycn-feature-needed", null, 2);
        i0.ɵɵelementStart(18, "ycn-pdf-title-modal", 15, 3);
        i0.ɵɵlistener("submitHandler", function FundChartHeaderComponent_Template_ycn_pdf_title_modal_submitHandler_18_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.exportPDF($event)); });
        i0.ɵɵelementEnd();
        i0.ɵɵelement(20, "ycn-loading-modal", 16);
    } if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("config", ctx.exportingOptions)("inputDisabled", !ctx.chartHasValidRequestData)("dropdownClass", "dropdown-menu-with-icons");
        i0.ɵɵadvance();
        i0.ɵɵproperty("config", ctx.sharingOptions)("dropdownClass", "dropdown-menu-with-icons");
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("embedCodeUrl", ctx.embedCodeUrl);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.selectedItem);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("defaultTitle", "New Fund Chart")("submitButtonText", "Download");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("loadingText", "Exporting PDF Report")("modalTrigger", i0.ɵɵpureFunction1(11, _c5, ctx.exportLoading));
    } }, dependencies: [i6.NgIf, i7.ChartEmbedModalComponent, i8.FeatureNeededComponent, i9.IconDirective, i10.LoadingModalComponent, i11.PdfTitleModalComponent, i12.SharingModalComponent, i13.SimpleDropdownComponent, i14.UrlShortenerModalComponent, i15.FundChartSavedItemDropdownComponent], encapsulation: 2 });
